import { z } from 'zod';
import { DocId, IsoTimestamp, TenantId } from '../common.js';
/**
 * A thema-kanaal ("Groepsgesprek"): a text-based, Slack-style channel for
 * SUPPOHRT-intern staff. Unlike a DM (exactly two participants, deterministic
 * id, see dm.ts + ADR 0002) a channel has a name, an owner, mutable content
 * and NO member list — visibility is by role (isInternalRole), so every
 * internal user sees every channel. Only suppohrt_admin creates channels.
 *
 * Firestore path: tenants/{tenantId}/thema_threads/{threadId}
 * threadId is random (not deterministic): duplicate channels are allowed.
 *
 * Content is shareable knowledge, NOT patient-identifiable casuïstiek: that
 * belongs in Directe Berichten. A channel where casuïstiek IS the point states
 * its own rule in `description`, which the UI shows instead of that default
 * (still non-identifiable). Channel content can be summarised into the
 * kennisbank (Ring 0) by an admin. See ADR 0004.
 */
export const ThemaThreadSchema = z.object({
    id: DocId,
    tenantId: TenantId,
    name: z.string().min(1).max(100),
    description: z.string().max(280).default(''),
    createdBy: DocId,
    lastMessageAt: IsoTimestamp.optional(),
    lastMessagePreview: z.string().max(80).optional(),
    createdAt: IsoTimestamp,
});
/**
 * A single message within a channel.
 *
 * Firestore path: tenants/{tenantId}/thema_threads/{threadId}/thema_messages/{messageId}
 */
export const ThemaMessageSchema = z.object({
    id: DocId,
    threadId: DocId,
    senderId: DocId,
    text: z.string().min(1).max(4000),
    createdAt: IsoTimestamp,
});
export const CreateThemaThreadInput = z.object({
    name: z.string().min(1).max(100).trim(),
    description: z.string().max(280).trim().optional(),
});
/**
 * Naam en onderschrift van een kanaal wijzigen (suppohrt_admin). Beide velden
 * zijn los optioneel, maar een lege patch is een vergissing en geen no-op die
 * we stil willen doorlaten.
 */
export const UpdateThemaThreadInput = z
    .object({
    name: z.string().min(1).max(100).trim().optional(),
    description: z.string().max(280).trim().optional(),
})
    .refine((v) => v.name !== undefined || v.description !== undefined, {
    message: 'Geef een naam of een onderschrift op',
});
//# sourceMappingURL=thema-thread.js.map